// save recently viewed items to local storage
var productHandle = document.querySelector('#product-info').getAttribute('data-product-handle');
var recentProducts = localStorage.getItem('vipstore-recently-viewed-products');
var saved = false;
if(recentProducts){
    recentProducts = JSON.parse(recentProducts)
    if(Array.isArray(recentProducts)){
        saved = recentProducts.some(product => product.handle === productHandle)
    }else{
        recentProducts = null;
    }
}
if(!recentProducts || !saved){
    var viewTimer = setTimeout(function(){
        if(!recentProducts){
            recentProducts = [];
        }
        recentProducts.push({
            handle: productHandle,
            time: new Date().getTime()
        })
        localStorage.setItem('vipstore-recently-viewed-products', JSON.stringify(recentProducts));
        clearTimeout(viewTimer)
    }, 1000)
}else if (saved){
    var viewTimer = setTimeout(function(){
        var i = recentProducts.findIndex((product) => product.handle == productHandle)
        recentProducts[i].time = new Date().getTime()
        localStorage.setItem('vipstore-recently-viewed-products', JSON.stringify(recentProducts));

        clearTimeout(viewTimer)
    }, 1000)
}

if(document.querySelector('#product-info .spr-starrating a')){
    var stars = document.querySelector('#product-info .spr-stars').outerHTML
    document.querySelector('#product-info .spr-starrating').innerHTML = stars + document.querySelector('#product-info .spr-starrating a').textContent.replace(' total', '');
}

if(document.querySelector('variant-radios')){
    document.querySelectorAll('variant-radios input').forEach(elem => {
        elem.addEventListener('click', function(e){
            e.target.parentNode.parentNode.parentNode.querySelector('legend .selection').textContent = e.target.value
        })
    })
}

// move title above images based on window width
var title_mobile = false;
function moveProductTitle(){
    if(window.innerWidth <= 930 && !title_mobile){
        var breadcrumb = document.querySelector('.breadcrumb');
        var title = document.querySelector('h1.product-title');
        var rating = document.querySelector('div[data-block-handle="star_rating"]');
        if(!document.querySelector('.title-rating')){
            div = document.createElement('div');
            div.classList.add('title-rating')
        }else{
            div = document.querySelector('.title-rating')
        }
        if(breadcrumb){
            div.append(breadcrumb)
        }
        div.append(title)
        if(rating){
            div.append(rating)
        }
        document.querySelector('#product-info').prepend(div)
        title_mobile = true;
    }else if(window.innerWidth > 930 && title_mobile){
        var breadcrumb = document.querySelector('.breadcrumb');
        var title = document.querySelector('h1.product-title').parentElement;
        var rating = document.querySelector('div[data-block-handle="star_rating"]');
        if(rating){
            document.querySelector('#product-info .content').prepend(rating)
        }
        document.querySelector('#product-info .content').prepend(title)
        if(breadcrumb){
            document.querySelector('#product-info .content').prepend(breadcrumb)
        }
        
        title_mobile = false;
    }
}

window.addEventListener('resize', moveProductTitle);
moveProductTitle()
if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class MediaGallery extends HTMLElement {
        constructor() {
            super();
            this.thumbnails = this.querySelector('.thumbnails')
            this.slider = this.querySelector('.image-slider');
            this.variantImages = this.querySelector('.variant-images')
            this.floatingAddToCart = document.querySelector('floating-add-to-cart')

            if(this.thumbnails){
                this.thumbnails.querySelectorAll('li button').forEach(elem => {
                    elem.addEventListener('click', this.scrollMedia.bind(this))
                })
                
                this.currentPage = 1;
                if(window.innerWidth > 1063){
                    this.perPage = 4;
                }else{
                    this.perPage = 3;
                }
                
                this.totalPages = this.thumbnails.querySelectorAll('li').length - this.perPage + 1;
                this.totalItems = this.thumbnails.querySelectorAll('li').length;
                
                this.thumbnails.querySelector('.next button').addEventListener('click', this.scrollThumbs.bind(this, 'next'))
                this.thumbnails.querySelector('.previous button').addEventListener('click', this.scrollThumbs.bind(this, 'previous'))
            }

            if(this.slider){
                this.slider.addEventListener('scroll', this.onSliderScroll.bind(this))
            }
            
            this.setActiveMedia.bind(this)
        }

        setActiveMedia(media_id){
            const mainSrc = this.variantImages.querySelector(`img[data-media-id="${media_id}"].main`).getAttribute('src')
            const newBaseSrc = mainSrc.substring(0, mainSrc.indexOf('?'))
            const curSrc = this.slider.querySelector('li:first-child img').getAttribute('src')
            const curBaseSrc = curSrc.substring(0, curSrc.indexOf('?'));
            
            this.slider.querySelector('li:first-child').setAttribute('data-media-id', media_id);
            this.slider.querySelector('li:first-child img').setAttribute('src', mainSrc);
            
            const newSrcset = this.slider.querySelector('li:first-child img').getAttribute('srcset').replaceAll(curBaseSrc, newBaseSrc)
            this.slider.querySelector('li:first-child img').setAttribute('srcset', newSrcset);
            
            if(this.thumbnails){
                const thumbSrc = this.variantImages.querySelector(`img[data-media-id="${media_id}"].thumb`).getAttribute('src')

                this.thumbnails.querySelector('li:first-child button').setAttribute('data-media-id', media_id);
                this.thumbnails.querySelector('li:first-child img').setAttribute('src', thumbSrc);

                const newThumbSrcset = this.thumbnails.querySelector('li:first-child img').getAttribute('srcset').replaceAll(curBaseSrc, newBaseSrc)
                this.thumbnails.querySelector('li:first-child img').setAttribute('srcset', newThumbSrcset);

                this.currentPage = 1;
                this.scrollThumbs('previous');
            }

            if(this.floatingAddToCart){
                this.floatingAddToCart.updateImage(newBaseSrc);
            }
        }

        onSliderScroll(e){
            const lis = this.slider.querySelectorAll('li');
            for(let i = 0; i < lis.length; i++){
                if(lis[i].getBoundingClientRect().left > 0){
                    this.thumbnails.querySelector('li[data-active]').removeAttribute('data-active');
                    this.thumbnails.querySelectorAll('li')[i].setAttribute('data-active', 'true')
                    if(i != this.currentPage - 1){
                        this.currentPage = i + 1;
                        if(this.currentPage == this.totalItems){
                            this.thumbnails.querySelector('.next button').setAttribute('disabled', 'disabled')
                        }else if(this.currentPage == 1){
                            this.thumbnails.querySelector('.previous button').setAttribute('disabled', 'disabled')
                        }else{
                            this.thumbnails.querySelector('.next button').removeAttribute('disabled')
                            this.thumbnails.querySelector('.previous button').removeAttribute('disabled')
                        }
                    }
                    break;
                }
            }
        }

        scrollMedia(e, media_id){
            if(e && !media_id){
                media_id = e.currentTarget.getAttribute('data-media-id');
            }
            this.thumbnails.querySelector('li[data-active]').removeAttribute('data-active');
            e.currentTarget.parentNode.setAttribute('data-active', 'true');

            const image = document.querySelector(`.image-slider li[data-media-id="${media_id}"]`)
            const scrollLeft = image.offsetLeft - document.querySelector('.image-slider').offsetLeft;
            document.querySelector('.image-slider').scrollTo(scrollLeft, 0)

            const thumbIndex = Array.from(this.thumbnails.querySelectorAll(`li`)).findIndex((elem) => {
                return elem.getAttribute('data-active') == 'true';
            });
            if(thumbIndex !== -1){
                this.currentPage = thumbIndex + 1;
                if(this.currentPage == this.totalItems){
                    this.thumbnails.querySelector('.next button').setAttribute('disabled', 'disabled')
                }else if(this.currentPage == 1){
                    this.thumbnails.querySelector('.previous button').setAttribute('disabled', 'disabled')
                }else{
                    this.thumbnails.querySelector('.next button').removeAttribute('disabled')
                    this.thumbnails.querySelector('.previous button').removeAttribute('disabled')
                }
                this.scrollThumbs()
            }
        }

        scrollThumbs(direction){
            if(direction == 'next'){
                if(this.currentPage < this.totalItems){
                    this.thumbnails.querySelector('.previous button').removeAttribute('disabled')
                    this.currentPage++;
                }
            }else if(direction == 'previous'){
                if(this.currentPage > 1){
                    this.thumbnails.querySelector('.next button').removeAttribute('disabled')
                    this.currentPage--;
                }
            }
            
            const scrollLeft = (this.thumbnails.querySelector('li').offsetWidth + 16) * (this.currentPage - 1);
            this.thumbnails.querySelector('ul').scrollTo({left: scrollLeft, top: 0, behavior: 'smooth'})

            this.thumbnails.querySelectorAll('li')[this.currentPage - 1].querySelector('button').click()
            
            if(direction == 'next'){
                if(this.currentPage == this.totalItems){
                    this.thumbnails.querySelector('.next button').setAttribute('disabled', 'disabled')
                }
            }else if(direction == 'previous'){
                if(this.currentPage == 1){
                    this.thumbnails.querySelector('.previous button').setAttribute('disabled', 'disabled')
                }
            }
        }
    })
}

if (!customElements.get('floating-add-to-cart')) {
    customElements.define('floating-add-to-cart', class FloatingAddToCart extends HTMLElement {
        constructor() {
            super();
            this.headerHeight = document.querySelector('header').offsetHeight;
            this.topAddToCart = document.querySelector('#product-info .content .add-to-cart')
            this.productDescription = document.querySelector('#product-description')
            this.inView = false;
            this.timeout = null;
            this.image = this.querySelector('img');
            this.querySelector('.edit').addEventListener('click', this.scrollBackUp.bind(this))

            window.addEventListener('scroll', this.onPageScroll.bind(this))
            this.onPageScroll()

            var _this = this;

            document.querySelector('quantity-input').addEventListener('change', function(e){
                _this.querySelector('.qty').textContent = e.target.value
            })

            this.querySelector('.add-to-cart').addEventListener('click', function(){
                _this.topAddToCart.click()
            })
        }

        onPageScroll(){
            if(
                !this.inView
                && this.topAddToCart.getBoundingClientRect().top < this.headerHeight
            ){
                this.style.position = 'sticky'
                this.style.bottom = '64px'
                this.inView = true;
            }else if(
                this.inView
                && this.topAddToCart.getBoundingClientRect().top > this.headerHeight
            ){
                this.style.bottom = `-${this.offsetHeight}px`
                if(!this.timeout){
                    this.timeout = setTimeout(() => {
                        this.style.position = 'static',
                        clearTimeout(this.timeout)
                        this.timeout = null
                    }, 200)
                }
                this.inView = false
            }
        }

        scrollBackUp(){
            window.scrollTo({
                left: 0,
                top: document.querySelector('#product-info .content').offsetTop - this.headerHeight,
                behavior: 'smooth',
                duration: 200
            })
        }

        updateImage(newSrc){
            let curSrc = this.image.getAttribute('src')
            let curBaseSrc = curSrc.substring(0, curSrc.indexOf('?'));
            this.image.setAttribute('src', curSrc.replace(curBaseSrc, newSrc));
        }
    })
}

// edit scarcity
    const stockTimeout = setInterval(() => {
        const stockBar = document.querySelector('.stock-top');
        if(stockBar){
          clearInterval(stockTimeout);
          const inventory = parseInt(document.querySelector('.stock-message-left').textContent.match(/-?\d+/));
          if(inventory > 80){
            document.querySelector('.stock-message-left').textContent = 'Hurry up! Limited stock available.';
            document.querySelector('.stock-progress-foreground').style.width = '80%';
          }
          if(inventory <= 75 && inventory > 51){
            stockBar.setAttribute('data-urgency', 'low');
          }
          if(inventory <= 50 && inventory > 26){
            stockBar.setAttribute('data-urgency', 'medium');
          }
          if(inventory <= 25 && inventory > 11){
            stockBar.setAttribute('data-urgency', 'high');
          }
          if(inventory <= 10){
            stockBar.setAttribute('data-urgency', 'very-high');
          }
          if(inventory > 0){
            stockBar.style.display = 'block';
          }
        }
    }, 800)

// move quantity breaks
const timeout = setInterval(() => {
    const qty_breaks = document.querySelector('.money-template');
    if(qty_breaks && qty_breaks.querySelector('#Buy1')){
        clearInterval(timeout);

        //auto select first bundle
        qty_breaks.querySelector('#Buy1').checked = true;

        // reword first option
        const firstPer = qty_breaks.querySelector('label[for="Buy1"] .each').textContent;
        qty_breaks.querySelector('label[for="Buy1"]').innerHTML = `Buy 1<span class="each">${firstPer.replace(' each', '')}</span>`
        
        // move quantity form
        const qty = document.querySelector('quantity-input');
        qty_breaks.querySelector('li:last-child').append(qty);

        // push cart button below bundles
        const cartButton = document.querySelector('.product-form button[type="submit"]');
        cartButton.before(qty_breaks);
        qty_breaks.setAttribute('data-active', 'true')

        changeQty()
    }
}, 800)

// make qty breaks buttons change quantity input and appear selected
function changeQty(){
    const inputs = document.querySelectorAll('.money-template input[name="bundle-size"]');
    inputs.forEach(input => {
        input.addEventListener('change', function(e){
            const qty = e.target.value;
            document.querySelector('#qty').value = qty;
            document.querySelector('.qty .decrease').removeAttribute('disabled')
        })
    })

    const curQty = document.querySelector('#qty').value;

    if(document.querySelector(`#Buy${curQty}`)){
        document.querySelector(`#Buy${curQty}`).checked = true;
    }

    document.querySelector('#qty').addEventListener('change', function(e){
        if(document.querySelector(`#Buy${e.target.value}`)){
            document.querySelector(`#Buy${e.target.value}`).checked = true;
        }
    })
}

/* if(document.querySelector('#product-description img')){
    document.querySelectorAll('#product-description img').forEach(function(img){
        const src = img.getAttribute('src');
        const srcset = `
            ${src.replace('_900x900.', '_556x556.')} 556w,
            ${src} 900w
        `;
        const sizes = `
            (max-width: 604px) 556px,
            900px
        `;
        img.setAttribute('srcset', srcset)
        img.setAttribute('sizes', sizes)
    })
} */